import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CalendarCheck, GraduationCap, DollarSign } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function WatchMeGrow() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-417">
      <div className="max-w-6xl mx-auto px-4" data-id="element-418">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-419">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-420" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-421">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-422">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-423">
              Lead Generation
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-424">
              Education Marketing
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-425">
              Paid Ads
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-426">
              Engage Machine
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-427">
            Watch Me Grow Learning Center
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-428">
            Turning Demand Into Enrollments in Just 90 Days
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-429">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-430">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-431">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-432">
                <CalendarCheck className="w-24 h-24 text-engage-yellow" data-id="element-433" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-434">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-435">
                  <CalendarCheck className="w-6 h-6 text-engage-yellow" data-id="element-436" />
                </div>
                <div data-id="element-437">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-438">
                    123
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-439">
                    School Tours
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-440">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-441">
                <GraduationCap className="w-24 h-24 text-engage-yellow" data-id="element-442" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-443">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-444">
                  <GraduationCap className="w-6 h-6 text-engage-yellow" data-id="element-445" />
                </div>
                <div data-id="element-446">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-447">
                    67
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-448">
                    Student Enrollments
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-449">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-450">
                <DollarSign className="w-24 h-24 text-engage-yellow" data-id="element-451" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-452">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-453">
                  <DollarSign className="w-6 h-6 text-engage-yellow" data-id="element-454" />
                </div>
                <div data-id="element-455">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-456">
                    27x
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-457">
                    Annual ROAS
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-458">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-459">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-460">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-461" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-462">
              Despite having a strong academic offering, the school operated
              with 0 predictable enrollment system, relying heavily on word of
              mouth and inconsistent marketing, which led to underfilled
              capacity and missed revenue opportunities. Even with clear demand
              in the market, there was no structured funnel to capture or
              convert it, resulting in lost enrollments and no reliable way to
              scale growth.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-463">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-464">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-465" />
              <div className="relative z-10" data-id="element-466">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-467">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-468" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-469">
                  We built a streamlined enrollment system centered around a
                  single conversion goal—booking school tours—which generated
                  123 qualified tour bookings in 90 days. By refining messaging
                  to match parent decision drivers and launching targeted
                  campaigns to attract high-intent local traffic, we optimized
                  every step of the funnel to efficiently move families from
                  initial interest to confirmed enrollment.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-470">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-471" />
              <div className="relative z-10" data-id="element-472">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-473">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-474" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-475">
                  In just 90 days, the school shifted from unpredictable growth
                  to a controlled system that generated 123 tours, converted
                  into 67 new student enrollments, and delivered a 27x annual
                  ROAS, turning what was once inconsistent into a repeatable,
                  scalable enrollment engine that drives results on demand.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-476">
            <div className="flex justify-center mb-8" data-id="element-477">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-478">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-479" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-480">
              We didn't just generate leads—we built a system that consistently
              turns demand into enrollments.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-481">
              <img src="https://cdn.magicpatterns.com/uploads/j9vzgDyKVGVYwakdCtvgED/Watch_Me_Grow-CS.png" alt="Watch Me Grow" className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 object-cover" data-id="element-482" />
              <div className="font-bold text-engage-white text-lg" data-id="element-483">
                Watch Me Grow Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-484">
                Watch Me Grow Learning Center
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-485">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-486" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-487">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-488">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-489">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-490">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}